module.exports = __webpack_public_path__ + "img/introducePageSeven_show_two.4ff01d44.jpg";